import "clsx";
import { F as Features } from "../../../../../chunks/Features.js";
function _page($$payload) {
  Features($$payload);
}
export {
  _page as default
};
